module.exports = __webpack_public_path__ + "h5/img/head-con.e6fbf81c.jpg";